import gql from "graphql-tag";

export const MAILFROM_ADDRESSES = gql`
	query MailFromAddresses {
		mailFromAddresses
	}
`;
